export const TITLE = "Work Type";

export const CLASS_NAMES = {
  container: "mb-6",
  title: "text-style-f-em text-neutral-800 mb-6",
  content: "mb-6",
  description:
    "text-style-f text-neutral-600 mt-1 md:text-style-g break-all child-ul:list-disc child-ol:list-decimal",
};
